import { Meteor } from 'meteor/meteor';
import { dataUrlToFile, randomString } from '/imports/utils';
import { AndroidDevice } from '/imports/types';
import { ensureAndroidDevice } from '/imports/api/users';
// import { Accounts } from '/imports/api/accounts';

const w = window as any;
export const AndroidClient = Meteor.isClient ? w.AndroidClient : null;

if (Meteor.isClient) {
  // w.webviewReady = () => {
  //   setTimeout(() => {
  //     const accountIds = Accounts.find().fetch().map((orgUser) => orgUser._id);
  //     if (accountIds.length) {
  //       setTimeout(() => AndroidClient.associateDevice(accountIds), 5000);
  //     }
  //   }, 1000);
  // };
  w.ensureAndroidDevice = async (device: AndroidDevice) => {
    try {
      await ensureAndroidDevice.call(device);
    }
    catch (error) {
      console.log(error);
    }
  };
}

export const initiateAndroidUpload = (handler: (file: File) => void) => {
  const listener = `androidUpload${randomString()}`;
  w[listener] = (name: string, fileB64: string) => {
    delete w[listener];
    const file = dataUrlToFile(fileB64, name);
    handler(file);
  };
  AndroidClient.initiateFileChooser(listener);
};

export const isAndroid = () => !!(window as any).AndroidClient;